import loading from './loading'
import clickOutside from './click-outside'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('loading', loading)
  nuxtApp.vueApp.directive('click-outside', clickOutside)
})
